var React = require( 'react' );
var createReactClass = require('create-react-class');

var SubscribeForm = createReactClass({

  handleSubmit: function(e){
    e.preventDefault()
    var email = this.refs.email.value.toLowerCase();
    this.props.subscribe(email);
  },

  render: function(){
    return (
      <div className="form">
          <form onSubmit={this.handleSubmit}>
              <label className="input">
                  <input className={this.props.newsletter.error.message ? 'error' : ''} type="email" name="email" ref="email" placeholder="john@example.com" required autoComplete="off" spellCheck="off" onFocus={this.props.clearError} />
                  <button className="button success" type="submit">Sign Up</button>
              </label>
              {this.props.newsletter.error.message &&
                  <p className="error">{this.props.newsletter.error.message}</p>
              }
          </form>
      </div>
    )
  }
});

module.exports = SubscribeForm;



// WEBPACK FOOTER //
// ./src/common/routes/home/components/subscribeForm.jsx